import React, { useState, useRef, useImperativeHandle, useCallback, useEffect } from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { CloseOutlined } from '@ant-design/icons';
import { Dropdown, DatePicker, Menu, TreeSelect, Tooltip, Select, Input } from 'antd';
import { MyIcon } from '@laigu/component';
import Cascader from '../cascader/index';
import style from './index.less';
import CountRange from './components/count-range';
import ListGroupSearch from './components/list-group-search';
import TagSelect from '../tag-select';

const { RangePicker } = DatePicker;
const { ListGroup } = Cascader;
const { SHOW_PARENT } = TreeSelect;
const { Search } = Input;

function stopPropagation(e) {
  if (e.nativeEvent.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation();
  }
  if (e.stopPropagation) {
    e.stopPropagation();
  }
}

const MenuCom = props => {
  const { data, handleChange } = props;
  return (
    <Menu
      className={style.filterMenu}
      items={data.map(item => ({
        key: item.value,
        label: <span>{item.label || item.name}</span>,
        onClick: () => handleChange([item.value])
      }))}
    />
  );
};

const defaultOriginalData = [];

const specialKey = ['not_exist', 'exist'];

const FilterItem = React.forwardRef((props, ref) => {
  const {
    column,
    clearFilterItem,
    value,
    open,
    filterChange,
    condition,
    originalData = defaultOriginalData,
    labelKey,
    allowClear = true,
    metaData,
    multiple = true,
    imageKey = '',
    showCheckedStrategy = SHOW_PARENT,
    disabled = false,
    // defaultValue改变后是否再执行onchange
    defaultOnChange = true,
    hasToolTip = false,
    hsaMaxWidth = true,
    withColomn = false,
    ...rest
  } = props;

  const {
    componentType,
    itemVisibleChange,
    filterDisabled,
    defaultValue,
    defaultCondition,
    clearAllCache = false
  } = rest;
  const refRange = useRef(null);
  const [visible, setVisible] = useState(open);
  const [result, setResult] = useState([]);
  const [groupList, setGroupList] = useState(defaultValue ? (multiple ? [defaultValue] : defaultValue) : []);
  const [labelData, setLabelData] = useState([]);
  const [hasCondition, sethasCondition] = useState(!!(condition && condition.length > 0));
  const [conditionData, setconditionData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [mouseEnter, setMouseEnter] = useState(false);
  const prevGroupList = useRef(null);

  useImperativeHandle(ref, () => ({
    clear: () => {
      clearFilter();
      if (clearAllCache) return;
      if (defaultValue != undefined) {
        dealDefaultValue();
        setGroupList(Array.isArray(defaultValue) ? defaultValue : [defaultValue]);
      }
    }
  }));

  const setLabelByValue = useCallback(
    value => {
      if (componentType === 'text') {
        setLabelData([value]);
        setGroupList(value);
        return;
      } else if (componentType === 'searchInput') {
        setLabelData([value]);
        setGroupList([value]);
        setIsEdit(!!value.length);

        return;
      } else if (componentType === 'countRange') {
        setLabelData([value?.label]);
        setGroupList([value]);
        setIsEdit(true);
        return;
      }
      if (multiple && Array.isArray(value)) {
        const t = [];
        value.forEach(res => {
          const target = originalData.find(x => x.id === res || x.value === res || x.key === res);
          if (target)
            t.push({
              ...target,
              label: target[labelKey]
            });
        });
        setLabelData(t);
        setGroupList(value);
        setIsEdit(!!value.length);
      } else {
        const target = originalData.find(x => x.id === value || x.value === value || x.key === value);
        if (target) {
          setLabelData([{ ...target, label: target[labelKey] }]);
          setGroupList(value);
          setIsEdit(!!value);
        }
      }
    },
    [originalData, multiple, componentType]
  );

  const dealDefaultValue = useCallback(() => {
    let realConditionData = conditionData;
    if (defaultCondition && condition?.length) {
      const target = condition?.find(x => x.value === defaultCondition);
      if (target) {
        handleChange(target);
        realConditionData = target;
      }
    }

    if (defaultValue != undefined) {
      if (componentType === 'switch') {
        filterChange([defaultValue], realConditionData, value, column);
        setIsEdit(defaultValue);
        return;
      }
      if (filterChange && !disabled && defaultOnChange) {
        filterChange(Array.isArray(defaultValue) ? defaultValue : [defaultValue], realConditionData, value, column);
      }

      setLabelByValue(defaultValue);
    }
  }, [defaultValue, setLabelByValue, disabled, defaultOnChange, defaultCondition]);

  // // 回显条件
  // useEffect(() => {
  //   if (!defaultCondition || !condition?.length) return;
  //   const target = condition?.find(x => x.value === defaultCondition);
  //   if (target) {
  //     handleChange(target);
  //   }
  // }, [defaultCondition, condition]);

  //有初始值的时候 显示编辑状态
  useEffect(() => {
    dealDefaultValue();
  }, [dealDefaultValue]);

  const change = useCallback(() => {}, []);

  const handleChange = useCallback(
    item => {
      setIsEdit(true);
      setResult([...result, item]);
      setconditionData(item);

      // 空和非空的情况下不需要后续选择
      if (specialKey.includes(item.value)) {
        setGroupList([true]);
        filterChange([], item, value, column);
        setVisible(false);
      } else {
        sethasCondition(false);
      }
    },
    [result]
  );

  const renderDom = useCallback(
    data => {
      return (
        <Menu
          className={style.filterMenu}
          items={data.map(item => ({
            key: item.value,
            label: <span>{String((item.label || item.name) ?? '')}</span>,
            onClick: () => handleChange(item)
          }))}
        />
      );
    },
    [handleChange]
  );

  //
  const onGroupChange = useCallback(
    e => {
      if (JSON.stringify(e) === JSON.stringify(defaultValue)) {
        return;
      }
      setLabelByValue(e);

      if (!multiple && filterChange) {
        // 如果是单选的直接返回值
        if (withColomn) {
          filterChange([e], null, null, column);
        } else {
          filterChange(e, null, column, column);
        }
        setVisible(false);
      }
    },
    [setLabelByValue, multiple, filterChange, defaultValue, withColomn]
  );

  const switchChange = useCallback(() => {
    if (filterDisabled) return;
    const values = [!groupList[0]];
    setGroupList(values);
    setIsEdit(!groupList[0]);
    filterChange(values, conditionData, value, column);
  }, [groupList, conditionData, value, column, filterDisabled]);

  /**
   * 渲染条件组件
   * @param {*} data
   * @returns
   */
  const renderTags = () => {
    let dom = null;
    const otherProps = rest?.otherProps ?? {};

    switch (componentType) {
      case 'countRange':
        dom = (
          <div className={style.select} style={{ width: 250 }}>
            {' '}
            <CountRange onChange={onGroupChange} value={groupList?.length ? groupList[0] : {}} />
          </div>
        );
        break;
      case 'searchInput':
        dom = (
          <div className={style.select}>
            <Search
              {...otherProps}
              value={groupList?.length ? groupList[0] : ''}
              onChange={e => onGroupChange(e.target.value)}
            ></Search>
          </div>
        );
        break;
      case 'select':
        dom = (
          <div className={style.select}>
            {visible && (
              <Select value={groupList} onChange={onGroupChange} placeholder={'请搜索'} {...otherProps}>
                {metaData?.map(x => (
                  <Select.Option value={x.value} title={x.label}>
                    {x.label}
                  </Select.Option>
                ))}
              </Select>
            )}
          </div>
        );

        break;
      case 'text':
        dom = defaultValue;
        break;

      case 'menu':
        dom = <MenuCom handleChange={onGroupChange} data={metaData} />;
        break;
      case 'rangePicker':
        dom = <RangePicker open={visible} getPopupContainer={() => refRange.current} onChange={change} />;
        break;
      case 'listgroup':
        dom = (
          <div className={style.tree}>
            <ListGroup
              onChange={onGroupChange}
              value={groupList}
              treeData={metaData}
              placeholder={'请选择'}
              multiple={multiple}
              className={style['tree-check']}
              showCheckedStrategy={showCheckedStrategy}
              {...rest}
              renderNode={rest.renderNode}
            />
          </div>
        );
        break;
      case 'tag':
        dom = (
          <div className={style.tree}>
            <TagSelect alwaysOpen multiple data={metaData} onChange={onGroupChange} />
          </div>
        );
        break;
      case 'listgroupSearch':
        dom = (
          <ListGroupSearch
            onGroupChange={onGroupChange}
            groupList={groupList}
            metaData={metaData}
            multiple={multiple}
            showCheckedStrategy={showCheckedStrategy}
            {...rest}
            visible={visible}
            renderNode={rest.renderNode}
          ></ListGroupSearch>
        );
        break;
    }
    return dom;
  };

  /**
   * 渲染选择结果
   */
  const renderResult = useCallback(() => {
    if (!rest) return;
    let label = rest.label;
    switch (value) {
      case 'clues':
        label = labelData.length ? '' : label;
        break;
      default:
        break;
    }

    const labelList = [];

    const showList = labelData.map((item, index) => {
      labelList.push(item?.label);
      if (typeof item === 'string') {
        return `${item}${index === labelData.length - 1 ? '' : '、'}`;
      } else {
        const img = item?.[imageKey];
        return (
          <>
            {img ? <img className={style.img} src={img} alt='' /> : null}
            {`${String(item.label ?? '')}${index === labelData.length - 1 ? '' : '、'}`}
          </>
        );
      }
    });

    return (
      <div className={style.info}>
        {rest.AntIcon ? (
          <LegacyIcon type={rest.AntIcon} className={style.icons} theme={rest?.noTheme ? '' : 'filled'} />
        ) : (
          <MyIcon className={`${style.icons} ${rest.icon} ${style.myIcon}`} type={rest.icon} />
        )}
        <>
          <span className={`${style.label} ${disabled ? style.disabled : ''}`}>{label}</span>
          {result.map(x => (
            <span style={{ marginRight: isEdit ? '0px' : '6px' }} key={x.label}>
              {String(x.label ?? '')}
            </span>
          ))}
          {hasToolTip ? <Tooltip title={labelList.join('、')}>{showList}</Tooltip> : showList}
        </>
      </div>
    );
  }, [rest, result, labelData, imageKey, hasToolTip, componentType]);

  const cancel = useCallback(
    e => {
      stopPropagation(e);
      clearFilterItem && clearFilterItem(value);
      if (itemVisibleChange) itemVisibleChange(false);
      clearFilter();
    },
    [clearFilterItem, value]
  );

  const clearFilter = () => {
    setIsEdit(false);
    setLabelData([]);
    setResult([]);
    setGroupList([]);
    sethasCondition(condition?.length > 0);
  };

  const visibleChange = useCallback(
    val => {
      if (!val) {
        let err = false;
        if (hasCondition) {
          if (condition.length > 0 && conditionData === null) err = true;
          if (groupList.length == 0 && !prevGroupList.current) err = true;
          //没有选中则清空筛选
          if (condition.length == 0 && !groupList.length) setIsEdit(false);
          if (groupList.length == 0 && prevGroupList.current) {
            setVisible(val);

            return clearFilterItem && clearFilterItem(value);
          }
        }
        prevGroupList.current = groupList;
        if (!err && filterChange) {
          if (JSON.stringify(groupList) === JSON.stringify(defaultValue)) {
            setVisible(false);
            return;
          }
          if (!specialKey.includes(conditionData?.value)) filterChange(groupList, conditionData, value, column);
        }
      }
      setVisible(val);
    },
    [groupList, condition, conditionData, value, filterChange, column, hasCondition, defaultValue]
  );

  const renderCondition = useCallback(condition => {
    return renderDom(condition);
  }, []);

  useEffect(() => {
    if (itemVisibleChange) itemVisibleChange(visible);
  }, [visible]);

  const setMouse = flag => {
    setMouseEnter(flag);
  };

  const showCancel = (result.length > 0 || labelData.length > 0) && mouseEnter && allowClear;

  if (disabled) {
    return <div className={`${style.resultWrap} ${style.disabled}`}>{renderResult()}</div>;
  }

  return <>
    {componentType === 'switch' ? (
      <div
        className={`${style.resultWrap} ${hsaMaxWidth ? style.maxWidth : ''} ${
          isEdit ? style.isEdit : style.noEdit
        } ${showCancel ? style.showCancel : ''}`}
        onClick={switchChange}
        onMouseEnter={() => setMouse(true)}
        onMouseLeave={() => setMouse(false)}
      >
        {renderResult()}
        {showCancel ? (
          <div onClick={cancel} className={style.cancel}>
            <CloseOutlined />
          </div>
        ) : null}
      </div>
    ) : (
      <Dropdown
        disabled={filterDisabled}
        onOpenChange={visibleChange}
        trigger={['click']}
        open={visible}
        dropdownRender={() => hasCondition ? renderCondition(condition) : renderTags()}
        overlayClassName={style.overlay}
      >
        <div
          className={`${style.resultWrap} ${hsaMaxWidth ? style.maxWidth : ''} ${
            isEdit ? style.isEdit : style.noEdit
          } ${showCancel ? style.showCancel : ''}`}
          onMouseEnter={() => setMouse(true)}
          onMouseLeave={() => setMouse(false)}
        >
          {renderResult()}
          {showCancel ? (
            <div onClick={cancel} className={style.cancel}>
              <CloseOutlined />
            </div>
          ) : null}
        </div>
      </Dropdown>
    )}
  </>;
});
export default FilterItem;
